// Auto-generated - do not edit manually
import React from "react";
import { FlagIcon } from "../FlagIcon";
import type { FlagIconProps } from "../types";

const svgContent = `<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="flag-icon_bd"><g id="flag"><mask id="mask0_1161_20324" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="1" y="3" width="16" height="12"><rect id="mask" x="1" y="3" width="16" height="12" fill="white"/></mask><g mask="url(#mask0_1161_20324)"><g id="contents"><rect id="background" x="1" y="3" width="16" height="12" fill="#38A17E"/><path id="Oval 3" fill-rule="evenodd" clip-rule="evenodd" d="M7 12C8.65685 12 10 10.6569 10 9C10 7.34315 8.65685 6 7 6C5.34315 6 4 7.34315 4 9C4 10.6569 5.34315 12 7 12Z" fill="#F72E45"/></g></g></g></g></svg>`;

export const FlagBD: React.FC<FlagIconProps> = (props) => (
  <FlagIcon {...props} svgContent={svgContent} />
);
